import React from 'react'
import { connect } from 'react-redux'
import translate from 'loankeeper-common/helpers/language'
import { fetchClientValidationNew, fetchClientValidation } from 'shared/ApplicationFactory/store'
import withConstantPermissions from 'shared/containers/withConstantPermissions'
import { actions as LKModalActions } from 'shared/LKModal'

import { checkReqFields as checkReqFieldsAction, clientSearch, loadClientDetails } from '../../../store/client'
import { Provider } from './select-client-context'
import ClientSearchModal from './ClientSearchModal'
import ClientEdit from '../../ClientEdit'
import { AppDispatch } from 'src/store/index.d'
import { ClientSearchAttributes } from '@lk/api'

export const CLIENT_SEARCH_MODAL = 'ClientSearchModal'
export const CLEAR_CLIENT_TYPES = {
  NOT_FOUND: 'NOT_FOUND',
  OTHER: 'OTHER',
}

const noop = () => {}

@withConstantPermissions()
@connect(undefined, {
  openSearch: (which) => {
    const modalOptions = { name: CLIENT_SEARCH_MODAL }

    if (typeof which === 'number') {
      modalOptions.which = which
    }

    return LKModalActions.open(modalOptions)
  },
  openError: (message) => LKModalActions.openError(message),

  // clientValidation: (ID, HashSum_ClientID_, clientGroup) => fetchClientValidation(ID, HashSum_ClientID_, clientGroup),
  //UPDATED API REQUEST client_oper_api page: checkreqfields
  clientValidation: (ID, HashSum_ClientID_, clientGroup) =>
    fetchClientValidationNew(ID, HashSum_ClientID_, clientGroup),
  loadClientDetails,
})
@connect(undefined, (dispatch: AppDispatch) => ({
  clientSearch: (params: ClientSearchAttributes) => dispatch(clientSearch(params)),
}))
class SelectClientProvider extends React.PureComponent {
  loadedClients = {}

  loadedCheckReqFields = {}

  static defaultProps = {
    onSelectClient: undefined,
    onClose: undefined,
    clientTypes: [1, 3],
    editClientProps: undefined,
    clientName: '',
  }

  state = {
    isFetching: false,
    lastPin: undefined,
    lastNotFoundPin: undefined,
  }

  getCheckReqFields = async (client, clientGroup, forceUpdateReqFields) => {
    const { ID, HashSum_ClientID_ } = client

    if (!forceUpdateReqFields && this.loadedCheckReqFields[ID]) {
      return this.loadedCheckReqFields[ID]
    }

    const result = await this.props.clientValidation(ID, HashSum_ClientID_, clientGroup)

    if (!checkReqFieldsAction.fulfilled.match(result)) {
      throw { Error: { Message: result.payload } }
    }

    this.loadedCheckReqFields[ID] = { Data: result.payload }

    return { Data: result.payload }
  }

  cacheClient = (client) => {
    this.loadedClients[client.CardNumber] = client
  }

  handleSelectClient = async (client, forceUpdateReqFields = false, type, params = {}) => {
    const { clientGroup, onSelectClient } = this.props

    this.cacheClient(client)

    let checkReqFields
    if (clientGroup) {
      checkReqFields = await this.getCheckReqFields(client, clientGroup, forceUpdateReqFields)
    }

    onSelectClient(client, checkReqFields, type, params.which)

    this.setState({ lastPin: client.CardNumber })
  }

  handleClientSearchFlags = (searchFlag, clientGroup, clientTypes) => {
    const types = clientTypes.join('')

    let flag = '1010001'

    if (searchFlag) {
      flag = searchFlag
    } else if (!searchFlag && clientGroup === 6) {
      flag = '1010001'
    } else if (types === '1') {
      flag = '1010001'
    } else if (types === '12') {
      flag = '1100001'
    } else if (types === '13') {
      flag = '1010001'
    } else if (types === '123') {
      flag = '1110001'
    }

    return flag
  }

  handleSearch = (searchType = 'NONE') => {
    const { onClear = noop, pin, clientSearchFlags, clientGroup, clientTypes } = this.props

    if (!pin) {
      onClear(CLEAR_CLIENT_TYPES.OTHER)
      this.loadedClients = {}
      this.setState({ lastPin: null })

      return
    }

    const searchFlag = this.handleClientSearchFlags(clientSearchFlags, clientGroup, clientTypes)

    if (searchType === 'ABORT_IF_UNCHANGED' && (pin === this.state.lastPin || pin === this.state.lastNotFoundPin)) {
      return
    }

    if (
      typeof this.loadedClients[pin] !== 'undefined' &&
      this.props.clientTypes.includes(this.loadedClients[pin].ClientType)
    ) {
      this.handleSelectClient(this.loadedClients[pin])
      return
    }

    this.setState({ isFetching: true, lastPin: pin }, async () => {
      try {
        const params = {
          page: 'searchexact',
          searchfield: 'personalno',
          searchflags: searchFlag,
          searchvalue: pin,
        }
        // const { Data: clients } = await Client.search(params)
        // .catch((err) => {
        //   this.setState(
        //     {
        //       lastNotFoundPin: pin,
        //     },
        //     () => {
        //       this.props.openError(translate(`LKMESSAGE-${err.Error.Message || err.Error.Text}`))
        //     },
        //   )
        // })

        //UPDATED API REQUEST 'client_search'
        const clients = await this.props
          .clientSearch(params)
          .unwrap()
          .catch((err) => {
            this.setState(
              {
                lastNotFoundPin: pin,
              },
              () => {
                this.props.openError(translate(`LKMESSAGE-${err.message || err.text}`))
              },
            )
          })

        if (clients.length === 1) {
          const [{ ...client }] = clients

          const clientDetailsResult = await this.props.loadClientDetails({
            clientId: client.ID,
            clientHash: client.HashSum_ClientID_,
          })

          if (loadClientDetails.fulfilled.match(clientDetailsResult)) {
            client.IDScanCount = clientDetailsResult.payload.IDScanCount
            client.CityID = clientDetailsResult.payload.CityID
          }

          this.cacheClient(client)

          this.handleSelectClient(client)
        } else {
          this.props.openError(translate('LKMESSAGE-ERR_CLIENT_NOT_FOUND'))
          onClear(CLEAR_CLIENT_TYPES.NOT_FOUND)
        }
      } catch (e) {
        onClear(CLEAR_CLIENT_TYPES.NOT_FOUND)
      } finally {
        this.setState({ isFetching: false })
      }
    })
  }

  handleAddOrUpdateClient = async ({ ClientID, HashSum_ClientID_ }) => {
    const clientDetailsResult = await this.props.loadClientDetails({
      clientId: ClientID,
      clientHash: HashSum_ClientID_,
    })

    if (loadClientDetails.fulfilled.match(clientDetailsResult)) {
      this.handleSelectClient(clientDetailsResult.payload, true, 'AddOrUpdate')
    }
  }

  render() {
    const { isFetching, lastPin } = this.state
    const { pin, clientGroup, permissions, openSearch, onClose, clientTypes, editClientProps, clientName } = this.props
    return (
      <Provider
        value={{
          pin: pin || '',
          lastPin,
          isFetching,
          onSearch: this.handleSearch,
          onAddOrUpdateClient: this.handleAddOrUpdateClient,
          openSearch,
          canViewClient: permissions.VIEW_CLIENT,
          clientGroup,
          clientTypes,
          clientName,
          mainClient: this.loadedClients[pin],
          lastClient: this.loadedClients[lastPin],
        }}
      >
        {editClientProps !== undefined && (
          <ClientEdit
            name={editClientProps.name}
            onClientEdit={this.handleAddOrUpdateClient}
            onClose={editClientProps.onClose}
          />
        )}
        <ClientSearchModal onSelectClient={this.handleSelectClient} onClose={onClose} clientTypes={clientTypes} />
        {this.props.children}
      </Provider>
    )
  }
}

export * from './SelectClientElements'

export default SelectClientProvider
